// extracted by mini-css-extract-plugin
module.exports = {"container":"part-other-cases_container__U47c7"};